import React, { Component } from "react";
import { Link } from "react-router-dom";
import { func, arrayOf, oneOfType, bool, number, string } from "prop-types";

import * as i18nUtils from "util/i18n";
import { actions as notificationActions } from "reducers/notification";
import { SALARY_PAYMENT_ID_FORM } from "constants.js";

import Box from "pages/_components/Box/Box";
import CustomData from "pages/_components/CustomData/CustomData";
import ItemName from "pages/_components/item/Name";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import TransactionStatus from "pages/transactions/_components/TransactionStatus";

class PendingTransactionsListItem extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        transaction: {
            activityName: string.isRequired,
            creationDateTime: string.isRequired,
            currency: arrayOf(oneOfType([number, string])),
            data: {
                amount: {
                    currency: string.isRequired,
                    quantity: number.isRequired,
                },
            },
            idForm: string.isRequired,
            idTransaction: string.isRequired,
            idTransactionStatus: string.isRequired,
            onlyDrafts: bool.isRequired,
            quantity: number,
            valueDateTime: string,
        },
    };

    static defaultProps = {
        transaction: {
            currency: null,
            quantity: null,
            valueDateTime: null,
            data: {
                amount: {
                    currency: null,
                    quantity: null,
                },
            },
        },
    };

    onMobileItemCLick = (event) => {
        const {
            dispatch,
            transaction: { idForm },
        } = this.props;

        if (idForm === SALARY_PAYMENT_ID_FORM) {
            event.preventDefault();
            dispatch(
                notificationActions.showNotification(i18nUtils.get("massive.payments.mobile.disable"), "error", [
                    "desktop",
                ]),
            );
        }
    };

    render() {
        const {
            transaction: {
                activityName,
                creationDateTime,
                data: { amount: { quantity, currency } = {} },
                idTransaction,
                idTransactionStatus,
                submitDateTime,
            },
        } = this.props;

        return (
            <Link
                className="grid-table-row"
                onClick={(e) => this.onMobileItemCLick(e)}
                to={`/transaction/${idTransaction}`}
                replace>
                <Box display="flex" alignX="left" alignY="center" className="text-left py-3">
                    <TransactionStatus idTransactionStatus={idTransactionStatus} showLabel iconFidelity="list" />
                </Box>
                <Box display="flex" alignX="right" alignY="center" className="text-right py-3">
                    <CustomData titleText={activityName} />
                </Box>
                <Box display="flex" alignY="top" column className="text-left py-3">
                    <CustomData
                        titleText={i18nUtils.get("transactions.list.item.created")}
                        valueText={<FormattedDate date={creationDateTime} />}
                    />
                </Box>
                <Box display="flex" alignX="right" alignY="bottom" column className="text-right py-3">
                    <CustomData
                        titleText={i18nUtils.get("transactions.list.item.sent")}
                        valueText={<FormattedDate date={submitDateTime} />}
                    />
                </Box>
                <Box display="flex" alignX="left" className="text-left py-3">
                    <ItemName name={i18nUtils.get("transactions.list.filter.searchBy.amount")} />
                </Box>
                <Box display="flex" alignX="right" className="text-right py-3 custom-data">
                    <FormattedAmount quantity={quantity} currency={currency} className="custom-data-value" />
                </Box>
            </Link>
        );
    }
}

export default PendingTransactionsListItem;
